import { render } from "./FormBtn.vue?vue&type=template&id=66c215b4"
import script from "./FormBtn.vue?vue&type=script&lang=js"
export * from "./FormBtn.vue?vue&type=script&lang=js"

import "./FormBtn.vue?vue&type=style&index=0&id=66c215b4&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__